import React, { useState } from "react";

export default function UpdateCastlePage() {
  const [castle, setCastle] = useState({
    profilePic: "https://w3s.link/ipfs/example-profile.jpg",
    bio: "Welcome to my crypt of creations and mysteries.",
    visibility: "public", // Default visibility
  });
  const [newProfilePic, setNewProfilePic] = useState(null);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCastle((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setNewProfilePic(selectedFile);
  };

  // Save changes
  const saveChanges = () => {
    // Example: Upload logic for the new profile picture
    if (newProfilePic) {
      const updatedPicUrl = URL.createObjectURL(newProfilePic); // Replace with upload logic
      setCastle((prev) => ({ ...prev, profilePic: updatedPicUrl }));
    }
    alert("Castle updated successfully!");
    window.location.href = "/"; // Redirect to Castle page
  };

  return (
    <div className="min-h-screen bg-brandBlack text-brandWhite p-6">
      <h1 className="text-4xl font-gothic text-center mb-6">UPDATE CASTLE</h1>

      {/* Profile Picture Section */}
      <div className="flex flex-col items-center mb-6">
        <img
          src={castle.profilePic}
          alt="Castle"
          className="w-24 h-24 rounded-full border-4 border-gray-400 mb-4"
        />
        <label className="text-gray-300">
          Upload New Profile Picture:
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="block mt-2"
          />
        </label>
      </div>

      {/* Bio Section */}
      <div className="mb-6">
        <label className="block text-gray-300 mb-2">Castle Bio:</label>
        <textarea
          name="bio"
          value={castle.bio}
          onChange={handleInputChange}
          className="w-full p-2 bg-transparent border border-gray-400 rounded text-white"
          rows="4"
        />
      </div>

      {/* Visibility Section */}
      <div className="mb-6">
        <label className="block text-gray-300 mb-2">Visibility:</label>
        <select
          name="visibility"
          value={castle.visibility}
          onChange={handleInputChange}
          className="p-2 bg-transparent border border-gray-400 rounded text-white"
        >
          <option value="public">Public</option>
          <option value="invite-only">Invite-only</option>
          <option value="hidden">Hidden</option>
        </select>
      </div>

      {/* Save Changes Button */}
      <div className="text-center">
        <button
          onClick={saveChanges}
          className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-600"
        >
          SAVE CHANGES
        </button>
      </div>
    </div>
  );
}
